import { createContext, useContext } from 'react';

export const ChartConfigContext = createContext<string>('');
export const useChartBlockId = () => {
  return useContext(ChartConfigContext);
};
